import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SharedModule } from '@shared/shared.module';

import { environment } from '@env/environment';

@Injectable({
  providedIn: SharedModule
})
export class ImageService {

  imageUrl = `${environment.apiBaseUrl}platform/image`;

  constructor(private http: HttpClient) { }

  uploadImage(formData: FormData): Observable<Base.ImageModel> {
    const headers = new HttpHeaders({
      'x-no-notification': 'true'
    });

    return this.http.post<Base.ImageModel>(`${this.imageUrl}`, formData, { headers });
  }
}
